<template>
  <div class="form-group">
    <h3 v-if="currentStep">Step {{ currentStep }}. Your travel preference</h3>

    <div class="form-row">
      <div class="radiolabel flighttype" :class="{ on: modelValue === 'Chaperoned' }" @click="$emit('update:modelValue', 'Chaperoned')">
        <div class="radio" />
        <label>
          <span>{{ config.label_flight_type_group || "Chaperoned" }}</span>
          <p>Travel with your group between the gateway airport and program destination.</p>
        </label>
      </div>
    </div>

    <div class="form-row">
      <div class="radiolabel flighttype" :class="{ on: modelValue === 'Individual' }" @click="$emit('update:modelValue', 'Individual')">
        <div class="radio" />
        <label>
          <span>{{ config.label_flight_type_individual || "Individual" }}</span>
          <p>Travel on your own and meet at the program destination.</p>
        </label>
      </div>
    </div>

    <div class="form-row">
      <div class="radiolabel flighttype" :class="{ on: modelValue === 'Undecided' }" @click="$emit('update:modelValue', 'Undecided')">
        <div class="radio" />
        <label>
          <span>Undecided</span>
          <p>View all options and decide depending on price.</p>
        </label>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  config: {
    type: Object,
    required: true,
  },
  currentStep: {
    type: Number,
    default: null,
  },
  modelValue: {
    type: String,
    default: "Chaperoned",
  },
});

defineEmits(["update:modelValue"]);
</script>

<style lang="less">
.flighttype p {
  color: @mid;
  margin-top: 0.25rem;
}
</style>
